<template>
  <fieldset
    v-loading="status.isOrderLoading"
    class="confirm-screen mt-10 mb-10 pl-30 pr-30"
    element-loading-text="Placing an order..."
    element-loading-custom-class="custom-spinner-class"
  >
    <div class="row">
      <div class="col-md-12">
        <h2>CONGRATULATIONS!</h2>
        <h4 class="mb-0">
          <b class="phone-number">1-855-754-5328</b> Save This Number
        </h4>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h4 class="mb-0">
          Gourmet Automated System
        </h4>
      </div>
      <div class="col-md-12">
        <div class="action-instruction">
          <b>Press 1</b> for on demand meal delivery (Gourmet)
        </div>
        <div class="action-instruction">
          <b>Press 2</b> for groceries
        </div>
        <div class="action-instruction">
          <b>Press 3</b> for rides or pharmacy pickup
        </div>
        <div class="action-instruction">
          <b>Press 4</b> to make changes on account
        </div>
        <div class="action-instruction">
          <b>Press 0</b> for an operator
        </div>
      </div>
    </div>

    <div class="form-submit-button-group mt-10">
      <p-button
        v-if="savedCart"
        id="btnPlace"
        type="purple"
        @click="onPlaceSavedCart()"
      >
        Place Order with Saved Cart
      </p-button>

      <p-button
        v-if="savedCart"
        id="btnEdit"
        type="primary"
        @click="onEditSavedCart()"
      >
        Edit Saved Cart
      </p-button>

      <p-button
        id="btnBack"
        type="yellow"
        @click="onDone()"
      >
        Done
      </p-button>
    </div>
  </fieldset>
</template>

<script lang="ts">
import utils from '@/Utils/util';
import { useGourmet } from '@/use/gourmet';
import { useSwalDialog } from '@/use/swalDialog';
import { nextTick, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useCustomer } from '@/use/customer';
import { gourmetService } from '@/services/gourmet';

export default {
  name: 'Confirmation',
  emits: ['init-registration-data'],
  setup: (props: any, context: any) => {
    const { emit } = context;

    const router = useRouter();
    const { newCustomerInfo } = useCustomer();
    const { savedCart, setSavedCart } = useGourmet();
    const { showSuccessPopupDialog, showErrorPopupDialog, showConfirmPopupDialog } = useSwalDialog();

    const status = reactive({
      isOrderLoading: false,
    });

    const onPlaceSavedCart = async () => {
      const htmlText = `
        <ul>
          <li style="text-align: left;">$1 hold for verification purposes</li>
          <li style="text-align: left; padding-top: 10px;">Call back within 1 hour if there are issues with the order</li>
          <li style="text-align: left; padding-top: 10px;">The customer should be available for calls until the order has been delivered</li>
          <li style="text-align: left; padding-top: 10px;"><b>Inform customer we cannot cancel order once it's been placed</b></li>
        </ul>
      `;

      const isConfirmed = await showConfirmPopupDialog({
        text: htmlText,
        title: 'Please Remind Customer',
        confirmButtonText: 'Order',
        cancelButtonText: 'Cancel',
        type: 'html',
        icon: 'warning',
      });

      if (!isConfirmed) {
        return;
      }

      try {
        status.isOrderLoading = true;

        await gourmetService.submitOrder({
          ...savedCart.value,
          callerId: newCustomerInfo.value.id,
        });

        setSavedCart(null);
        showSuccessPopupDialog({
          text: 'The order has been placed successfully.',
        });
      } catch (error: any) {
        const errorText = utils.getGraphqlError(error, false);

        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        status.isOrderLoading = false;
      }
    };

    const onEditSavedCart = () => {
      router.push({
        name: 'DeliverySearch',
        query: { phoneNumber: newCustomerInfo.value.phoneNumber, loadSavedCart: 'true' },
      });
    };

    const onDone = () => {
      setSavedCart(null);
      emit('init-registration-data');
    };

    return {
      savedCart,
      status,
      onDone,
      onPlaceSavedCart,
      onEditSavedCart,
    };
  },
};
</script>

<style lang="scss">
.confirm-screen {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
  @media (max-width: 576px) {
    max-width: unset;
    padding: 10px 20px 0;
  }
  h2 {
    font-size: 26px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0 25px;
  }
  h4 {
    margin-top: 0;
    font-size: 18px;
    color: #000 !important;
  }
  .action-instruction {
    font-size: 18px;
  }
}
</style>
